var TextHelpers = /** @class */ (function () {
    function TextHelpers() {
    }
    /**
     * Decode HTML (removes escape html)
     *
     * @param {string} encoded html
     * @returns {string} decoded html
     */
    TextHelpers.htmlDecode = function (content) {
        if (document) {
            var e = document.createElement('div');
            e.innerHTML = content;
            return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
        }
    };
    return TextHelpers;
}());

export { TextHelpers as default };
//# sourceMappingURL=text.util.js.map
